import React from 'react';
import { Divider, List, Table } from 'antd';
import { KeyValueWidget } from 'components/KeyValueWidget';
import styles from './styles.module.less';

/**
 * ReportTable component renders a table with a header and a footer.
 * @param {Object} props - The props for the component.
 * @param {string} props.rowKey - The key to identify each row uniquely.
 * @param {Array} props.data - The data for the table.
 * @param {Array} props.headerOne - The header for the first column.
 * @param {Array} props.headerTwo - The header for the second column.
 * @param {Array} props.columns - The columns for the table.
 * @param {Array} props.footer - The footer for the table.
 * @param {Array} props.summaryData - The summary data for the table.
 * @param {boolean} props.disableScroll - If true, the table will not be scrollable.
 * @returns {JSX.Element} The rendered table component.
 */
export default function ReportTable({
  rowKey,
  data,
  headerOne = [],
  headerTwo = [],
  columns = [],
  footer = null,
  summaryData = null,
  disableScroll = false,
}) {
  return (
    <Table
      className={styles.tableReport}
      columns={columns}
      dataSource={data}
      rowKey={rowKey}
      bordered
      scroll={disableScroll ? undefined : { x: 'max-content' }}
      title={() => (
        <div className="gx-flex-column">
          <div className="gx-flex-row gx-guarnic-gap-2">
            {headerOne?.map(h => (
              <KeyValueWidget
                labelClass={styles.tableHeader}
                valueClass={styles.tableHeader}
                key={h.label}
                label={h.label}
                value={h.value}
              />
            ))}
          </div>
          {headerOne.length > 0 && headerTwo.length > 0 && <Divider />}
          <div className="gx-flex-row">
            <div className="gx-flex-row gx-guarnic-gap-2">
              {headerTwo?.map(h => (
                <KeyValueWidget
                  labelClass={styles.tableHeader}
                  valueClass={styles.tableHeader}
                  key={h.label}
                  label={h.label}
                  value={h.value}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      pagination={false}
      footer={
        !footer
          ? null
          : () => (
              <List
                size="small"
                dataSource={footer}
                renderItem={item => (
                  <List.Item>
                    <div className={styles.footerData}>
                      <div>{item.label}</div>
                      <div>{item.value}</div>
                    </div>
                  </List.Item>
                )}
              />
            )
      }
      summary={() =>
        summaryData && summaryData?.length ? (
          <Table.Summary fixed>
            <Table.Summary.Row>
              {summaryData.map((item, index) => (
                <Table.Summary.Cell key={index} className={styles.summaryData} index={index}>
                  {item}
                </Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          </Table.Summary>
        ) : null
      }
    />
  );
}
